<script lang="ts">
  import Input from '$shared/atoms/Input/Input.svelte';
  import CustomCreate from './CustomCreate.svelte';
  import DropdownListItem from './DropdownListItem.svelte';

  interface Props {
    list?: CommonList[];
    maxheight?: boolean;
    canCreate?: boolean;
    canCreateOnInput?: boolean;
    placeholder?: string;
    oninputcreate?: (value: string) => void;
    onclick?: (item: CommonList) => void;
    oncreate?: (value: string) => void;
  }

  let {
    list = [],
    maxheight = false,
    canCreate = false,
    canCreateOnInput = false,
    placeholder = '',
    oninputcreate,
    onclick,
    oncreate
  }: Props = $props();

  let searchValue = $state('');
  let inputElement: Input = $state();

  let filteredList = $derived(searchValue
    ? list.filter((item) => item?.label?.toLowerCase().includes(searchValue.toLowerCase()))
    : list);

  let isValueMatch = $derived(!!filteredList.find((item) => item.label === searchValue));

  export const focus = (): void => {
    inputElement?.focus();
  };

  const onSearch = ({ value }: { value: string }): void => {
    searchValue = value;

    canCreateOnInput && oninputcreate?.(searchValue);
  };

  const onClickItem = (item: CommonList): void => {
    onclick?.(item);
  };

  const onClickCustom = (): void => {
    oncreate?.(searchValue);
  };
</script>

<div class="searchable-list" class:maxheight>
  <div class="search-input">
    <Input
      bind:this={inputElement}
      placeholder={placeholder || 'Search item'}
      oninput={onSearch}
    />
  </div>

  <div class="searchable-list-container">
    {#each filteredList as item}
      <DropdownListItem {item} onclick={() => onClickItem(item)} />
    {:else}
      {#if !canCreate}
        <div class="empty">No data found</div>
      {/if}
    {/each}
    {#if canCreate && (filteredList.length === 0 || !isValueMatch)}
      <CustomCreate value={searchValue} label={'Custom'} onclick={onClickCustom} />
    {/if}
  </div>
</div>

<style>
  .searchable-list.maxheight .searchable-list-container {
    max-height: 100%;
  }
  .search-input {
    padding: 6px;
  }
  .searchable-list-container {
    width: 100%;
    display: inline-block;
    max-height: calc(300px - 50px);
    overflow: auto;
  }
  .empty {
    background-color: var(--grey-bg);
    line-height: 30px;
    padding: 0 8px;
    color: var(--grey-light);
  }
</style>
